import React from "react";
import "./AboutPage.css"; // Asegúrate de crear este archivo CSS para los estilos personalizados

function AboutPage() {
  return (
    <section className="card">
      <div className="card-body">
        <h1>📣 Acerca de  📣</h1>
        <p>
          Bienvenido a nuestra plataforma especializada en la gestión integral de ventas Tienda a Tienda (TaT) para distribuidoras de productos desechables y congelados. Desarrollamos soluciones tecnológicas adaptadas a las necesidades específicas de la distribuidora, optimizando los procesos y proporcionando herramientas clave para el crecimiento y la eficiencia del negocio.
        </p>
        <h2>Visión General</h2>
        <p>
          Nuestra plataforma nace con la misión de ofrecer a la distribuidora de Fontibón una solución integral para la gestión de ventas, inventario y clientes. Buscamos modernizar y potenciar la operación de la empresa, permitiendo una administración más eficiente y proporcionando a los clientes una experiencia de compra optimizada.
        </p>
        <h2>Características Principales</h2>
        <ul>
          <li><strong>Gestión de Ventas:</strong> Realice pedidos de manera fácil y rápida a través de nuestra plataforma, con notificaciones automáticas sobre cambios de precios y promociones exclusivas.</li>
          <li><strong>Administración de Usuarios:</strong> Plataforma segura con opciones para registrar, modificar y eliminar cuentas, adaptadas a las responsabilidades específicas de cada usuario.</li>
          <li><strong>Manejo de Inventarios:</strong> Control preciso del inventario con actualizaciones automáticas para mantener información precisa.</li>
          <li><strong>Informes y Estadísticas:</strong> Generación de informes detallados para evaluar el rendimiento del negocio.</li>
          <li><strong>Medios de Pago:</strong> Variadas opciones de pago para mayor comodidad del cliente.</li>
          <li><strong>Notificaciones Personalizadas:</strong> Envío de notificaciones automáticas con cambios de precio y promociones exclusivas.</li>
          <li><strong>Foco en Fontibón:</strong> Diseñado para mejorar la distribución y entrega de mercancía en esta localidad.</li>
        </ul>
        <h2>🔊 Beneficios</h2>
        <ul>
          <li><strong>Eficiencia Operativa:</strong> Optimización de procesos para un manejo más eficiente de las operaciones diarias.</li>
          <li><strong>Experiencia del Cliente:</strong> Mejora en la experiencia de compra con opciones intuitivas y notificaciones relevantes.</li>
          <li><strong>Crecimiento Sostenible:</strong> Herramientas clave para el crecimiento y la adaptación a nuevas demandas.</li>
        </ul>
        <p>
          <strong>En SellerTaT, estamos comprometidos con la innovación y la excelencia, ofreciendo una solución tecnológica adaptada a las necesidades específicas de la distribuidora. ¡Únase a nosotros en el viaje hacia el futuro de la gestión comercial en el mercado Tienda a Tienda!</strong>
        </p>
      </div>
    </section>
  );
}

export default AboutPage;
